import { UserRoleDTO } from "./UserRoleDTO";

export class InsertAuctionToEauctionsRequestDTO {
    auctionCodes:string[];
    userId: string;
    loggedInUser : UserRoleDTO;
}
